import { combineReducers } from 'redux'
import _ from 'lodash'

import {
  FETCH_ITEMS,
  FETCH_ITEMS_SUCCESS,
  FETCH_ITEMS_FAIL,
  FETCH_ITEM,
  FETCH_ITEM_SUCCESS,
  SAVE_FILTER,
  FETCH_FILTER,
  FETCH_FILTER_SUCCESS,
  SAVE_SORT,
  FETCH_SORT,
  FETCH_SORT_SUCCESS,
  DELETE_SINGLE_ITEM_SUCCESS,
  SET_SORT,
  NEXT_PAGE,
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  UPLOAD_FILE_PROGRESS,
  CANCEL_UPLOAD
} from 'react-redux/actions/asset'

import { RESET } from 'react-redux/actions/app'

const initialState = {
  items: {}, // available assets as returned by the backend
  list: [],
  uploads: {},
  uploadList: [],

  fetchingList: false,
  filter: {
    initialized: false,
    expression: "",
    fetching: false
  },
  pagination: {
    reachedEnd: false,
    page: 0,
    maxResults: 3,
  },
  query: {
    filter: null,
    page: null,
    sort_by_field: null,
    reverse_order: null,
    max_results: null
  },
  pendingQuery: null,
  sort: {
    initialized: false,
    field: "name",
    fetching: false,
    reverse: {
      name: false,
      fileName: false,
      timeCreated: false,
      timeModified: false
    }
  }
}

export const list = (state = initialState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialState)
    }
    case FETCH_ITEMS: {
      const {filter, page, sort_by_field, reverse_order, max_results} = action.payload
      const pendingQuery =  {
        filter,
        page,
        sort_by_field,
        reverse_order,
        max_results
      }
      return Object.assign(
        {},
        state,
        {
          pendingQuery,
          fetchingList: true
        }
      )
    }
    case FETCH_ITEMS_SUCCESS: {
      // TODO remove hack when implemeted
      const {query, pendingQuery, pagination} = state
      let items = Object.assign({}, state.items)
      let list = []
      action.payload.forEach((item)=>{
        const uid = item.id
        items[uid] = Object.assign({}, item.data, item.stats)
        items[uid].fetching = false
        list.push(uid)
      })
      const reachedEnd = (list.length < state.pendingQuery.max_results-1)
      const clear = query.filter !== pendingQuery.filter
        || query.sort_by_field !== pendingQuery.sort_by_field
        || query.reverse_order !== pendingQuery.reverse_order
      list = clear ? list: state.list.concat(list)
      let i = 0
      let uploadList = [].concat(state.uploadList)
      while (i<uploadList.length) {
        const tid = uploadList[i]
        if (list.indexOf(state.uploads[tid].uid) != -1) uploadList.splice(i,1)
        else i++
      }
      return Object.assign(
        {},
        state,
        {
          items,
          query: Object.assign({}, pendingQuery),
          pendingQuery: null,
          list,
          uploadList,
          pagination: Object.assign(
            {},
            pagination,
            {
              reachedEnd,
              page: pendingQuery.page
            }
          ),
          fetchingList: false
        }
      )
    }
    case FETCH_ITEMS_FAIL: {
      const { pagination, pendingQuery } = state
      return Object.assign(
        {},
        state,
        {
          list: [],
          query: Object.assign({}, pendingQuery),
          pendingQuery: null,
          fetchingList: false,
          pagination: Object.assign(
            {},
            pagination,
            {
              reachedEnd: true,
              page: 0
            }
          ),
        }
      )
    }
    case DELETE_SINGLE_ITEM_SUCCESS: {
      const items = Object.assign({}, state.items)
      if (items[action.context.payload.uid]) delete items[action.context.payload.uid]
      const list = _.without(state.list, action.context.payload.uid)
      const uploads = Object.assign({}, state.uploads)
      let tid
      for (tid in uploads) {
        if (uploads[tid].uid === action.context.payload.uid) break
      }
      delete uploads[tid]
      const uploadList = _.without(state.uploadList, tid)
      return Object.assign({}, state, {items, list, uploads, uploadList})
    }
    case NEXT_PAGE: {
      if (state.reachedEnd || state.fetchingList) return state
      let pagination = Object.assign({}, state.pagination)
      pagination.page++
      return Object.assign({}, state, {pagination})
    }
    case FETCH_ITEM: {
      let items = _.merge({}, state.items)
      if (items[action.payload.uid]) items[action.payload.uid].fetching = true
      return Object.assign({}, state, {items})
    }
    case FETCH_ITEM_SUCCESS: {
      let items = _.merge({}, state.items)
      items[action.context.payload.uid] = action.payload
      items[action.context.payload.uid].fetching = false
      return Object.assign({}, state, {items})
    }
    case SAVE_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { expression: action.payload}
      )
      return Object.assign({}, state, { filter } )
    }
    case FETCH_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { fetching: true }
      )
      return Object.assign({}, state, { filter })
    }
    case FETCH_FILTER_SUCCESS: {
      const filter = Object.assign(
        {},
        state.filter,
        {
          expression: action.payload || "",
          fetching: false,
          initialized: true
        }
      )
      return Object.assign(
        {},
        state,
        {
          filter
        }
      )
    }
    case SAVE_SORT: {
      const {field, reverse} = action.payload
      const sort = Object.assign(
        {},
        state.sort,
        { field, reverse }
      )
      return Object.assign({}, state, { sort } )
    }
    case FETCH_SORT: {
      const sort = Object.assign(
        {},
        state.sort,
        { fetching: true }
      )
      return Object.assign({}, state, { sort })
    }
    case FETCH_SORT_SUCCESS: {
      let sort = Object.assign(
        {},
        state.sort,
        {
          fetching: false,
          initialized: true
        }
      )
      if (action.payload && action.payload.field)
        sort.field = action.payload.field
      if (action.payload && action.payload.reverse)
        sort.reverse = action.payload.reverse
      return Object.assign(
        {},
        state,
        { sort }
      )
    }
    case UPLOAD_FILE: {
      const { transactionId, payload } = action
      const { size, name, type } = payload
      const uploads = Object.assign({}, state.uploads)
      uploads[transactionId] = { size, name, type, progress: 0, completed: false }
      const uploadList = [].concat(state.uploadList)
      uploadList.unshift(transactionId)
      return Object.assign(
        {},
        state,
        { uploads, uploadList }
      )
    }
    case UPLOAD_FILE_PROGRESS: {
      const { transactionId, payload } = action
      const uploads = _.cloneDeep(state.uploads)
      uploads[transactionId].progress = payload.loaded / payload.total
      return Object.assign(
        {},
        state,
        { uploads }
      )
    }
    case UPLOAD_FILE_SUCCESS: {
      const { transactionId, payload } = action
      const uploads = _.cloneDeep(state.uploads)
      uploads[transactionId].progress = 1
      uploads[transactionId].uid = payload.id
      uploads[transactionId].completed = true
      return Object.assign(
        {},
        state,
        { uploads }
      )
    }
    case CANCEL_UPLOAD: {
      const { payload } = action
      const uploads = _.cloneDeep(state.uploads)
      delete uploads[payload]
      const uploadList = _.without(state.uploadList, payload)
      return Object.assign(
        {},
        state,
        { uploads, uploadList }
      )
    }
    default:
      return state
  }
}

export default combineReducers({
  list
})



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/asset.js